<template>
  <div class="fail" v-if="errors">
    <div class="redirectText">Oopsie, doopsie! Something went south...</div>
  </div>
  <div class="redirect" v-else-if="!errors && !expired">
    <div class="redirectText">Just a moment while we redirect you...</div>
  </div>
  <div class="redirect" v-else-if="!errors && expired">
    <div class="redirectText">Link no longer valid. Try again.</div>
  </div>
</template>

<script>
import auth from "../../api/auth";

export default {
  name: "PassResetRedirectPage",
  data() {
    return {
      errors: false,
      expired: false,
    };
  },
  async created() {
    try {
      const response = await auth.passResetRedirect(this.$route.params.token);
      if (response && response.status === 303) {
        /* this.$router.push("/account/passreset"); */
        window.location = "/account/passreset";
      } else if (!response.success) {
        this.expired = true;
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 303) {
          console.error(err);
          /* this.$router.push("/account/passreset"); */
          window.location = "/account/passreset";
        } else if (err.response.status === 401) {
          this.expired = true;
        } else {
          this.errors = true;
        }
      } else {
        this.errors = true;
      }
    }
  },
};
</script>

<style scoped>
.fail,
.redirect {
  margin: auto;
  width: 655px;
  font-size: 28px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 655px;
  border-radius: 360px;
  background-color: #f5f7f9;
  margin-top: 52px;
  box-shadow: 0px 7px 8px 1px #afbdca3b;
  transition: 0.2s ease-in-out;
}

.fail:hover,
.redirect:hover {
  transform: scale(1.01);
}

.redirectText {
  color: #484b4e;
}

@media only screen and (max-width: 750px) {
  .fail,
  .redirect {
    width: 450px;
    height: 450px;
    font-size: 19px;
  }
}
</style>
